// Cloudflare Turnstile loader utilities, kept out of the component to reduce its complexity.
export const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;
export const TURNSTILE_ENABLED = Boolean(SITE_KEY);

// Ensures the CF script tag exists, then invokes window.turnstile.ready(cb).
// Returns a cancel function to stop pending work on unmount.
export function whenTurnstileReady(cb) {
  let cancelled = false;
  let pollId = null;
  const ready = () => { if (!cancelled && window.turnstile) window.turnstile.ready(cb); };

  if (window.turnstile) {
    window.turnstile.ready(cb);
  } else {
    if (!document.getElementById("cf-turnstile-script")) {
      const s = document.createElement("script");
      s.id = "cf-turnstile-script";
      s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      s.async = false;
      document.head.appendChild(s);
    }
    const start = Date.now();
    pollId = setInterval(() => {
      if (cancelled || window.turnstile || Date.now() - start > 10000) {
        clearInterval(pollId);
        ready();
      }
    }, 100);
  }

  return () => { cancelled = true; if (pollId) clearInterval(pollId); };
}
